import {log} from 'santa-core-utils'

export const name = 'LoggerAspect'

export const defaultModel = {
    logger: log
}
